'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _CwShellLeftNavLink = require('./CwShellLeftNavLink.scss');

var _CwShellLeftNavLink2 = _interopRequireDefault(_CwShellLeftNavLink);

var _CwImage = require('../../cwimage/CwImage');

var _CwImage2 = _interopRequireDefault(_CwImage);

var _CwLabel = require('../../cwlabel/CwLabel');

var _CwLabel2 = _interopRequireDefault(_CwLabel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CwShellLeftNavLink = function CwShellLeftNavLink(props) {
  var _cx;

  var iconSource = props.active ? props.collapseIcon : props.expandIcon;

  var linkClass = (0, _classnames2.default)(_CwShellLeftNavLink2.default.cwShellLeftNavLink, (_cx = {}, (0, _defineProperty3.default)(_cx, _CwShellLeftNavLink2.default.active, props.active), (0, _defineProperty3.default)(_cx, _CwShellLeftNavLink2.default.skinny, props.noBorder), _cx));

  var subLinkContainerClass = (0, _classnames2.default)(_CwShellLeftNavLink2.default.cwShellLeftNavSubLinkContainer, (0, _defineProperty3.default)({}, _CwShellLeftNavLink2.default.active, props.active));

  var handleClick = function handleClick() {
    // fire onClick callback if it exists
    if (typeof props.onClick === 'function') {
      props.onClick();
    }
    // set this as the active link if the menu is in FAT mode
    if (typeof props.setActiveLink === 'function') {
      props.setActiveLink(props.active ? null : props.id);
    }
  };

  var renderChildren = function renderChildren() {
    return _react2.default.Children.map(props.children, function (child) {
      return _react2.default.cloneElement(child, {
        cwId: props.cwId,
        active: props.activeLink === child.props.id,
        collapseIcon: props.collapseIcon,
        expandIcon: props.expandIcon,
        setActiveLink: props.setActiveLink,
        noBorder: props.noBorder
      });
    });
  };

  return _react2.default.createElement(
    'div',
    null,
    _react2.default.createElement(
      'div',
      {
        'data-cwid': props.cwId + '_link_' + props.id,
        className: linkClass,
        onClick: handleClick
      },
      _react2.default.createElement(
        _CwLabel2.default,
        {
          cwId: props.cwId + '_link_' + props.id + '_label',
          className: _CwShellLeftNavLink2.default.cwShellLeftNavButtonLabel
        },
        props.label
      ),
      props.children.length !== 0 && _react2.default.createElement(_CwImage2.default, {
        cwId: props.cwId + '_link_' + props.id + '_icon',
        className: _CwShellLeftNavLink2.default.cwShellLeftNavLinkIcon,
        src: iconSource
      })
    ),
    props.active && _react2.default.createElement(
      'div',
      { className: subLinkContainerClass },
      renderChildren()
    )
  );
};

CwShellLeftNavLink.propTypes = {
  children: _propTypes2.default.oneOfType([_propTypes2.default.shape({
    type: _propTypes2.default.oneOf([CwShellLeftNavLink])
  }), _propTypes2.default.arrayOf(_propTypes2.default.shape({
    type: _propTypes2.default.oneOf([CwShellLeftNavLink])
  }))]),
  /**
   *  Connectwise element id to be used as unique identifier
   **/
  cwId: _propTypes2.default.string,
  /**
   * Unique identifier
   */
  id: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.string]),
  /**
   * Determines if the 'active' class is applied to button
   */
  active: _propTypes2.default.bool,
  /**
   * Path to collapse icon
   */
  collapseIcon: _propTypes2.default.string,
  /**
   * Path to collapse icon
   */
  expandIcon: _propTypes2.default.string,
  /**
   * Text Displayed
   */
  label: _propTypes2.default.string.isRequired,
  /**
   * Callback function that is fired on mouse click
   */
  onClick: _propTypes2.default.func,
  /**
   * Callback function to set the active link
   */
  setActiveLink: _propTypes2.default.func,
  /**
   * Determines if left border is needed on active
   */
  noBorder: _propTypes2.default.bool
};

CwShellLeftNavLink.defaultProps = {
  children: []
};

exports.default = CwShellLeftNavLink;


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui/lib/components/cwshellleftnav/cwshellleftnavlink/CwShellLeftNavLink.js
// module id = 854
// module chunks = 10